module.exports = __webpack_public_path__ + "media/images/client-37-4644998c59023ff9e5bf40e0f645ee3d.png";